<template>
    <div class="whatsapp-contact">
        <v-btn fab fixed bottom class="whatsapp-btn" 
               color="green" :href="whatsappLink" target="_blank" elevation="6">
            <v-icon color="white" size="28">mdi-whatsapp</v-icon>
        </v-btn>
        <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="tooltip-target"></div>
            </template>
            <span>{{ $t('contact.whatsapp_tooltip') }}</span>
        </v-tooltip>
    </div>
</template>

<style scoped lang="scss">
.whatsapp-contact {
    position: fixed;
    bottom: 20px;
    z-index: 1000;
    left: 20px;
}

.whatsapp-btn {
    animation: floatIn 0.9s ease-out, softBreath 3.2s ease-in-out infinite 1s;
    box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4) !important;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    position: relative;

    &::before,
    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
    }

    &::before {
        border: 2px solid rgba(37, 211, 102, 0.45);
        animation: sonar 2.8s ease-out infinite;
    }

    &::after {
        border: 2px solid rgba(37, 211, 102, 0.3);
        animation: sonar 2.8s ease-out infinite 1.4s;
    }

    &:hover {
        transform: translateY(-4px) scale(1.08);
        box-shadow: 0 6px 30px rgba(37, 211, 102, 0.6) !important;

        .v-icon {
            animation: nudge 0.55s ease-in-out;
        }
    }
}

@keyframes floatIn {
    0% {
        opacity: 0;
        transform: translateY(22px) scale(0.88);
    }

    60% {
        opacity: 1;
        transform: translateY(-4px) scale(1.03);
    }

    100% {
        transform: translateY(0) scale(1);
    }
}

@keyframes softBreath {
    0%,
    100% {
        transform: translateY(0);
        box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
    }

    50% {
        transform: translateY(-3px);
        box-shadow: 0 8px 30px rgba(37, 211, 102, 0.55);
    }
}

@keyframes sonar {
    0% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0.55;
    }

    100% {
        transform: translate(-50%, -50%) scale(2.05);
        opacity: 0;
    }
}

@keyframes nudge {
    0%,
    100% {
        transform: translateX(0);
    }

    30% {
        transform: translateX(2px);
    }

    60% {
        transform: translateX(-2px);
    }
}

.tooltip-target {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

@media (max-width: 600px) {
    .whatsapp-contact {
        left: 16px;
        bottom: 16px;
    }

    .whatsapp-btn {
        width: 48px !important;
        height: 48px !important;
        
        ::v-deep .v-icon {
            font-size: 26px !important;
        }
    }
}
</style>

<script>
export default {
    name: 'whatsapp-contact',
    computed: {
        whatsappLink() {
            const phone = "201558025577";
            const message = encodeURIComponent(this.$t('contact.whatsapp_message'));
            return `https://wa.me/${phone}?text=${message}`;
        }
    }
}
</script>
